import { CSSProperties } from 'react';
import theme from '../../theme';

export const styles = (): Record<string, CSSProperties> => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  icon: {
    cursor: 'pointer',
    height: theme.space[32],
    width: theme.space[32]
  },
  monthIcon: {
    cursor: 'pointer',
    height: theme.space[32],
    width: theme.space[90]
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    columnGap: theme.space[12]
  }
});
